<template>
  <main class="public-unit-detail">
    <header class="hero">
      <div class="hero-content">
        <img src="/img/osfatun-cuotas-logo.png" alt="OSFATUN - Nuestro plan es cuidarte" />
        <h1>DATOS Y UNIDADES</h1>
        <h3>{{ delegation.name || "INTEGRANTES DE LA UNIDAD" }}</h3>
      </div>
    </header>

    <section class="detail-card">
      <router-link class="back" to="/datos-y-unidades">← Volver a todas las unidades</router-link>
      <p v-if="loading" class="status">Cargando integrantes…</p>
      <p v-else-if="error" class="status error">{{ error }}</p>

      <template v-else>
        <div class="unit-summary">
          <div>
            <span class="type">{{ typeLabel(delegation.type) }}</span>
            <h2>{{ delegation.name }}</h2>
            <p>{{ [delegation.address, delegation.city, delegation.province, delegation.postal_code].filter(Boolean).join(" · ") }}</p>
          </div>
          <div class="summary-contact">
            <a v-if="delegation.phone" :href="`tel:${cleanPhone(delegation.phone)}`">{{ delegation.phone }}</a>
            <a v-if="delegation.email" :href="`mailto:${delegation.email}`">{{ delegation.email }}</a>
          </div>
        </div>

        <template v-if="isCasaCentral">
          <section v-if="gerencies.length" class="organization-section">
            <h2>Gerencias de OSFATUN</h2>
            <div class="people-grid">
              <article v-for="gerency in gerencies" :key="gerency.id || gerency.name" class="person-card featured">
                <p class="role-group">{{ gerency.name }}</p>
                <Person :person="gerency.manager" />
              </article>
            </div>
          </section>

          <section v-if="bossSections.length" class="organization-section">
            <h2>Jefaturas departamentales</h2>
            <div class="people-grid">
              <article v-for="section in bossSections" :key="section.name" class="person-card featured">
                <p class="role-group">{{ section.name }}</p>
                <Person :person="section.boss" />
              </article>
            </div>
          </section>

          <section v-if="departaments.length" class="organization-section">
            <h2>Departamentos de OSFATUN</h2>
            <div v-for="departament in departaments" :key="departament.id || departament.name" class="department">
              <h3>{{ departament.name }}</h3>
              <div class="people-grid">
                <article v-for="user in departament.users" :key="user.id" class="person-card">
                  <Person :person="user" />
                </article>
              </div>
            </div>
          </section>
        </template>

        <section v-else class="organization-section">
          <h2>Integrantes de la delegación</h2>
          <div v-if="users.length" class="people-grid">
            <article v-for="user in users" :key="user.id" class="person-card">
              <Person :person="user" />
            </article>
          </div>
          <p v-else class="empty">No hay integrantes publicados para esta unidad.</p>
        </section>
      </template>
    </section>
  </main>
</template>

<script>
import axios from "axios";
import Person from "../../components/public/PublicPerson.vue";

export default {
  name: "PublicUnidadDetalle",
  components: { Person },
  data() {
    return { delegation: {}, users: [], gerencies: [], departaments: [], bossSections: [], loading: true, error: "" };
  },
  computed: {
    apiBase() { return process.env.VUE_APP_ROOT_API || "https://api.osfatun.com.ar"; },
    isCasaCentral() { return Number(this.$route.params.id) === 114; },
  },
  mounted() { this.load(); },
  methods: {
    load() {
      const url = this.isCasaCentral ? `${this.apiBase}/api/getCasaCentral` : `${this.apiBase}/api/delegation/${this.$route.params.id}`;
      axios.get(url).then(({ data }) => {
        this.delegation = data.delegation || {};
        if (this.isCasaCentral) {
          this.gerencies = (data.gerencies || []).filter(item => item.manager);
          this.departaments = (data.departamentos || []).filter(item => Array.isArray(item.users) && item.users.length);
          this.bossSections = [data.prestaciones].filter(item => item && item.boss);
        } else {
          this.users = Array.isArray(this.delegation.user) ? this.delegation.user : [];
        }
      }).catch(() => { this.error = "No se pudo cargar la información de esta unidad."; })
        .finally(() => { this.loading = false; });
    },
    typeLabel(type) { return type ? type.replace(/\b\w/g, letter => letter.toUpperCase()) : "Unidad OSFATUN"; },
    cleanPhone(phone) { return String(phone || "").replace(/\D/g, ""); },
  },
};
</script>

<style scoped>
.public-unit-detail { min-height: 100vh; padding-bottom: 64px; background: #f4f7f8; color: #264653; }
.hero { min-height: 330px; padding: 42px max(6vw, 24px) 104px; color: #fff; background-color: #007f91; background-image: linear-gradient(rgba(0, 112, 132, .12), rgba(0, 112, 132, .12)), url('/img/osfatun-cuotas-header.png'); background-position: center; background-size: cover; }
.hero-content { width: min(1100px, 100%); margin: 0 auto; display: flex; flex-direction: column; align-items: center; text-align: center; }.hero img { width: 100%; max-width: 220px; height: auto; margin-bottom: 75px; }.hero h1 { margin: 0; color: #fff; font-size: 42px; font-weight: 800; line-height: 1.05; }.hero h3 { margin: 14px 0 0; color: #fff; font-size: 18px; font-weight: 700; line-height: 1.35; text-transform: uppercase; }
.detail-card { width: min(1220px, 92vw); margin: -52px auto 0; padding: 32px; border-radius: 16px; background: #fff; box-shadow: 0 16px 45px rgba(18, 61, 72, .15); }.back { display: inline-block; margin-bottom: 24px; color: #00758f; font-weight: 700; }.unit-summary { display: flex; justify-content: space-between; gap: 30px; padding-bottom: 26px; border-bottom: 1px solid #dce7e9; }.type { color: #f4a51c; font-size: 11px; font-weight: 800; letter-spacing: .08em; text-transform: uppercase; }.unit-summary h2 { margin: 5px 0; color: #00758f; font-size: 27px; }.unit-summary p { margin: 0; }.summary-contact { display: flex; flex-direction: column; align-items: flex-end; gap: 8px; }.summary-contact a { color: #00758f; }
.organization-section { margin-top: 34px; }.organization-section > h2 { margin: 0 0 18px; color: #00758f; font-size: 22px; text-transform: uppercase; }.people-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 16px; }.person-card { padding: 18px; border: 1px solid #dce7e9; border-radius: 11px; background: #fff; }.person-card.featured { border-top: 4px solid #f4a51c; }.role-group { margin: 0 0 14px; color: #00758f; font-size: 13px; font-weight: 800; text-transform: uppercase; }.department { margin-top: 26px; }.department > h3 { margin: 0 0 12px; color: #f4a51c; font-size: 17px; }.status, .empty { padding: 42px 20px; text-align: center; }.status.error { color: #b42318; }
@media (max-width: 760px) { .hero { min-height: 280px; padding: 32px 20px 82px; }.hero h1 { font-size: 34px; }.detail-card { padding: 22px; }.unit-summary { flex-direction: column; }.summary-contact { align-items: flex-start; }.people-grid { grid-template-columns: 1fr; } }
</style>
